var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.iftop),expression:"iftop"}],staticClass:"totop flexCenter",on:{"click":_vm.backTop}},[_c('i',{staticClass:"el-icon-top",staticStyle:{"color":"#FFFFFF"}})]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }